// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HubSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HubSignetIcon" ref={forwardedRef} {...props}>
      <path d="m11.764 4.328-.008.804c.008.817-.55 1.164-.55 1.164s-.922.548-2.3 1.303c-1.95 1.069-1.503 2.854-1.501 2.865L6.595 9.99 4.237 8.608c-1.135-.666-1.124-2.31.02-2.96l4.954-2.817c1.143-.649 2.563.183 2.553 1.497" />
      <path d="M11.69 15.719c-.008 1.316-1.438 2.127-2.572 1.463L4.201 14.3c-1.134-.666-1.123-2.31.02-2.96 0 0 .632-.336 1.099-.557a.91.91 0 0 1 .853.037l5.044 2.959a.91.91 0 0 1 .45.758 51 51 0 0 1 .023 1.182" />
      <path d="M8.307 10.22 8.3 10.17l.005.049.007.043q0 .013.004.025zm-.012-.158q-.003-.046-.002-.093L8.292 9.995l.001.038v.01q0 .01.002.019" />
      <path d="M8.307 10.22 8.3 10.17l.005.049.007.043q0 .013.004.025zM8.292 9.995l.001.038v.01q0 .01.002.019-.003-.046-.002-.093z" />
      <path d="M14.093 5.69 9.111 8.566c-1.133.654-1.133 2.29 0 2.944l4.982 2.877c1.133.654 2.55-.164 2.55-1.472V7.162c0-1.308-1.417-2.126-2.55-1.472m-4.081 5.358a1.042 1.042 0 1 1 0-2.084 1.042 1.042 0 0 1 0 2.084m1.558.786a.39.39 0 0 1-.45.043l-.006-.004a.317.317 0 0 1-.034-.525 1.71 1.71 0 0 0 .648-1.343 1.68 1.68 0 0 0-.608-1.31.317.317 0 0 1 .041-.519l.004-.002a.39.39 0 0 1 .456.048 2.4 2.4 0 0 1 .787 1.784 2.45 2.45 0 0 1-.838 1.828" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HubSignetIcon = /* @__PURE__ */ Object.assign(
  HubSignetIconComponent,
  { displayName: 'HubSignetIcon' },
);
